import { createSvgIcon } from "@mui/material";

const CorporateAccountingIcon = createSvgIcon(
  <svg viewBox="0 0 180 180" fill="none">
    <path
      d="M0 45.7143C0 20.467 21.4903 0 48 0H132C158.51 0 180 20.467 180 45.7143V134.286C180 159.533 158.51 180 132 180H48C21.4903 180 0 159.533 0 134.286V45.7143Z"
      fill="var(--subtle-surface-bg, #F6F8FA)"
    />
    <path
      d="M60.6895 62.3213C60.6895 55.6939 66.062 50.3213 72.6895 50.3213H126.812C133.44 50.3213 138.812 55.6939 138.812 62.3213V131.687C138.812 138.314 133.44 143.687 126.812 143.687H72.6895C66.062 143.687 60.6895 138.314 60.6895 131.687V62.3213Z"
      fill="#B3E5FC"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M42.8916 40.6016C42.8916 38.6686 44.4586 37.1016 46.3916 37.1016H133.77C135.703 37.1016 137.27 38.6686 137.27 40.6016C137.27 42.5346 135.703 44.1016 133.77 44.1016H46.3916C44.4586 44.1016 42.8916 42.5346 42.8916 40.6016Z"
      fill="#136B94"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M128.132 37.1016C130.065 37.1016 131.632 38.6686 131.632 40.6016V85.79C131.632 87.723 130.065 89.29 128.132 89.29C126.199 89.29 124.632 87.723 124.632 85.79V40.6016C124.632 38.6686 126.199 37.1016 128.132 37.1016Z"
      fill="#136B94"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M52.0283 74.4355C53.9613 74.4355 55.5283 76.0026 55.5283 77.9355V124.057C55.5283 128.752 59.3339 132.557 64.0283 132.557H84.3287C86.2617 132.557 87.8287 134.124 87.8287 136.057C87.8287 137.99 86.2617 139.557 84.3287 139.557H64.0283C55.4679 139.557 48.5283 132.618 48.5283 124.057V77.9355C48.5283 76.0026 50.0953 74.4355 52.0283 74.4355Z"
      fill="#136B94"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M52.0283 37.1016C53.9613 37.1016 55.5283 38.6686 55.5283 40.6016V61.7414C55.5283 63.6744 53.9613 65.2414 52.0283 65.2414C50.0953 65.2414 48.5283 63.6744 48.5283 61.7414V40.6016C48.5283 38.6686 50.0953 37.1016 52.0283 37.1016Z"
      fill="#136B94"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M98.8302 99.1599C99.4392 98.0218 100.625 97.3114 101.916 97.3114H136.812C138.745 97.3114 140.312 98.8784 140.312 100.811V107.791C140.312 109.724 138.745 111.291 136.812 111.291C134.879 111.291 133.312 109.724 133.312 107.791V104.311H108.456L118.787 119.807C119.57 120.983 119.57 122.515 118.787 123.69L108.456 139.186H133.312V135.707C133.312 133.774 134.879 132.207 136.812 132.207C138.745 132.207 140.312 133.774 140.312 135.707V142.686C140.312 144.619 138.745 146.186 136.812 146.186H101.916C100.625 146.186 99.4392 145.476 98.8302 144.338C98.2211 143.2 98.2878 141.819 99.0038 140.745L111.668 121.749L99.0038 102.753C98.2878 101.679 98.2211 100.298 98.8302 99.1599Z"
      fill="#136B94"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M64.2041 57.4541C64.2041 55.5211 65.7711 53.9541 67.7041 53.9541H81.7041C83.6371 53.9541 85.2041 55.5211 85.2041 57.4541V71.4541C85.2041 73.3871 83.6371 74.9541 81.7041 74.9541H67.7041C65.7711 74.9541 64.2041 73.3871 64.2041 71.4541V57.4541ZM71.2041 60.9541V67.9541H78.2041V60.9541H71.2041Z"
      fill="#136B94"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M94.9561 57.4541C94.9561 55.5211 96.5231 53.9541 98.4561 53.9541H112.456C114.389 53.9541 115.956 55.5211 115.956 57.4541V71.4541C115.956 73.3871 114.389 74.9541 112.456 74.9541H98.4561C96.5231 74.9541 94.9561 73.3871 94.9561 71.4541V57.4541ZM101.956 60.9541V67.9541H108.956V60.9541H101.956Z"
      fill="#136B94"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M64.2041 85.79C64.2041 83.857 65.7711 82.29 67.7041 82.29H81.7041C83.6371 82.29 85.2041 83.857 85.2041 85.79V99.79C85.2041 101.723 83.6371 103.29 81.7041 103.29H67.7041C65.7711 103.29 64.2041 101.723 64.2041 99.79V85.79ZM71.2041 89.29V96.29H78.2041V89.29H71.2041Z"
      fill="#136B94"
    />
  </svg>,
  "CorporateAccountingIcon"
);

export default CorporateAccountingIcon;
